import React from 'react'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectEmail } from 'root-redux/selects/user'

import mailImage from 'assets/images/mail-image.webp'

import { StyledInboxNotice as S } from './InboxNotice.styles'

type TProps = {
  className?: string
}

export const InboxNotice: React.FC<TProps> = ({ className }) => {
  const email = useSelector(selectEmail)

  if (!email) {
    return null
  }

  return (
    <S.Card className={className}>
      <S.Image src={mailImage} alt="" />

      <S.Info>
        <S.Title>
          <Trans i18nKey="wellnessInbox.title" />
        </S.Title>

        <S.Description>
          <Trans
            i18nKey="wellnessInbox.description"
            values={{ email }}
            components={{ email: <S.Email /> }}
          />
        </S.Description>
      </S.Info>
    </S.Card>
  )
}
